
import { createReducer } from '@reduxjs/toolkit';
import { IFacilityShiftCreateState, IWorkerSuggestionsState, IFacilityShiftUpdateState, IFacilityShiftDetailsState, IAssignWorkersState, IShiftExtensionState, IDeleteCancelledShiftState } from './types';
import { createFacilityShift, fetchWorkerSuggestions, updateFacilityShift, fetchShiftDetails, assignWorkers, resetAssignWorkerState, resetFacilityShiftCreateState, resetFacilityShiftUpdateState, validateExtendShiftTime, extendShiftTime, resetShiftExtensionState, createPastFacilityShift, updatePastFacilityShift, resetFacilityShiftPastCreateState, resetFacilityShiftPastUpdateState, deleteCancelledShift, resetDeleteCancelledShiftState } from './actions';

const initialFacilityShiftCreateState: IFacilityShiftCreateState = {
  loading: false,
  data: null,
  error: null,
};

export const facilityShiftCreateReducer = createReducer(initialFacilityShiftCreateState, (builder) => {
  builder
    .addCase(resetFacilityShiftCreateState, (state) => {
      state.loading = false;
      state.data = null;
      state.error = null;
      state.message = null;
    })
    .addCase(createFacilityShift.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(createFacilityShift.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload.data || null;
      state.message = action.payload.message || null;
    })
    .addCase(createFacilityShift.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload as string;
      state.message = null;
    });
});

const initialFacilityShiftPastCreateState: IFacilityShiftCreateState = {
  loading: false,
  data: null,
  error: null,
};

export const facilityShiftPastCreateReducer = createReducer(initialFacilityShiftPastCreateState, (builder) => {
  builder
    .addCase(resetFacilityShiftPastCreateState, (state) => {
      state.loading = false;
      state.data = null;
      state.error = null;
      state.message = null;
    })
    .addCase(createPastFacilityShift.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(createPastFacilityShift.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload.data || null;
      state.message = action.payload.message || null;
    })
    .addCase(createPastFacilityShift.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload as string;
      state.message = null;
    });
});

const initialFacilityShiftUpdateState: IFacilityShiftUpdateState = {
  loading: false,
  data: null,
  error: null,
};

export const facilityShiftUpdateReducer = createReducer(initialFacilityShiftUpdateState, (builder) => {
  builder
    .addCase(resetFacilityShiftUpdateState, (state) => {
      state.loading = false;
      state.data = null;
      state.error = null;
      state.message = null;
    })
    .addCase(updateFacilityShift.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(updateFacilityShift.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload.data || null;
      state.message = action.payload.message || null;
    })
    .addCase(updateFacilityShift.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload as string;
      state.message = null;
    });
});

const initialFacilityShiftPastUpdateState: IFacilityShiftUpdateState = {
  loading: false,
  data: null,
  error: null,
};

export const facilityShiftPastUpdateReducer = createReducer(initialFacilityShiftPastUpdateState, (builder) => {
  builder
    .addCase(resetFacilityShiftPastUpdateState, (state) => {
      state.loading = false;
      state.data = null;
      state.error = null;
      state.message = null;
    })
    .addCase(updatePastFacilityShift.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(updatePastFacilityShift.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload.data || null;
      state.message = action.payload.message || null;
    })
    .addCase(updatePastFacilityShift.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload as string;
      state.message = null;
    });
});

const initialShiftDetailsState: IFacilityShiftDetailsState = {
  loading: false,
  data: null,
  error: null,
};

export const facilityShiftDetailsReducer = createReducer(initialShiftDetailsState, (builder) => {
  builder
    .addCase(fetchShiftDetails.pending, (state) => {
      state.loading = true;
      state.error = null;
      state.data = null;
    })
    .addCase(fetchShiftDetails.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload;
    })
    .addCase(fetchShiftDetails.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload as string;
    });
});

const initialWorkerSuggestionsState: IWorkerSuggestionsState = {
  loading: false,
  data: [],
  total_workers: 0,
  error: null,
};

export const workerSuggestionsReducer = createReducer(initialWorkerSuggestionsState, (builder) => {
  builder
    .addCase(fetchWorkerSuggestions.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(fetchWorkerSuggestions.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload.workers;
      state.total_workers = action.payload.total_workers;
    })
    .addCase(fetchWorkerSuggestions.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload as string;
    });
});

const initialAssignWorkersState: IAssignWorkersState = {
  loading: false,
  success: false,
  data: null,
  error: null,
};

export const assignWorkersReducer = createReducer(initialAssignWorkersState, (builder) => {
  builder
    .addCase(resetAssignWorkerState, (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
      state.data = null;
    })
    .addCase(assignWorkers.pending, (state) => {
      state.loading = true;
      state.success = false;
      state.error = null;
    })
    .addCase(assignWorkers.fulfilled, (state, action) => {
      state.loading = false;
      state.success = true;
      state.data = action.payload as any;
    })
    .addCase(assignWorkers.rejected, (state, action) => {
      state.loading = false;
      state.success = false;
      state.error = action.payload as string;
    });
});

const initialShiftExtensionState: IShiftExtensionState = {
  extending: false,
  validating: false,
  validationConflicts: [],
  validationError: null,
  extensionError: null,
  extensionSuccess: false,
  validationSuccess: false,
  validationMessage: undefined,
  extensionMessage: undefined,
};

export const shiftExtensionReducer = createReducer(initialShiftExtensionState, (builder) => {
  builder
    .addCase(resetShiftExtensionState, (state) => {
      state.extending = false;
      state.validating = false;
      state.validationConflicts = [];
      state.validationError = null;
      state.extensionError = null;
      state.extensionSuccess = false;
      state.validationSuccess = false;
      state.validationMessage = undefined;
      state.extensionMessage = undefined;
    })
    // Validation
    .addCase(validateExtendShiftTime.pending, (state) => {
      state.validating = true;
      state.validationError = null;
      state.validationSuccess = false;
      state.validationConflicts = [];
    })
    .addCase(validateExtendShiftTime.fulfilled, (state, action) => {
      state.validating = false;
      if (action.payload.valid) {
        state.validationSuccess = true;
        state.validationConflicts = [];
      } else {
        state.validationSuccess = false;
        state.validationConflicts = action.payload.conflicts || [];
      }
      state.validationMessage = action.payload.message;
    })
    .addCase(validateExtendShiftTime.rejected, (state, action: any) => {
      state.validating = false;
      state.validationSuccess = false;
      if (action.payload?.conflicts) {
        state.validationConflicts = action.payload.conflicts;
      }
      state.validationError = action.payload?.message || action.payload as string;
    })
    // Extension
    .addCase(extendShiftTime.pending, (state) => {
      state.extending = true;
      state.extensionError = null;
      state.extensionSuccess = false;
    })
    .addCase(extendShiftTime.fulfilled, (state, action) => {
      state.extending = false;
      state.extensionSuccess = true;
      state.extensionMessage = action.payload.message;
    })
    .addCase(extendShiftTime.rejected, (state, action) => {
      state.extending = false;
      state.extensionSuccess = false;
      state.extensionError = action.payload as string;
    });
});

const initialDeleteCancelledShiftState: IDeleteCancelledShiftState = {
  loading: false,
  success: false,
  error: null,
  message: null,
};

export const deleteCancelledShiftReducer = createReducer(initialDeleteCancelledShiftState, (builder) => {
  builder
    .addCase(resetDeleteCancelledShiftState, (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
      state.message = null;
    })
    .addCase(deleteCancelledShift.pending, (state) => {
      state.loading = true;
      state.success = false;
      state.error = null;
    })
    .addCase(deleteCancelledShift.fulfilled, (state, action) => {
      state.loading = false;
      state.success = true;
      state.message = action.payload?.message || null;
    })
    .addCase(deleteCancelledShift.rejected, (state, action) => {
      state.loading = false;
      state.success = false;
      state.error = action.payload as string;
    });
});
